import * as React from 'react'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, index }) => {
  const { props } = input

  const { helpText, ...childComponentProps } = props

  return (
    <div>
      <GenericInput
        className="bp5-fill"
        onChange={v => onFormPreviewChange(index, v)}
        title={props.label}
        requiredLabelStyle={templateStyles.requiredLabel}
        {...childComponentProps}
        required={props.required && isEmpty(props.value)}
      />
      {props.helpText && (
        <Help>
          <div>{props.helpText}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.props
  return (
    <div>
      <GenericInput title="Placeholder" value={inputProps.placeholder} onChange={v => onChange('placeholder', v)} />
    </div>
  )
}
